import script from "./AllProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./AllProjects.vue?vue&type=script&setup=true&lang=js"

import "./AllProjects.vue?vue&type=style&index=0&id=2707d92d&lang=scss"

const __exports__ = script;

export default __exports__